import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TypeTenantsProps } from "@/pages/Tenants";
import { ShowTenantBtn } from "@/App/Tenants/Show";
import { Mask } from "@/utils/mask";
import { DeleteTenantBtn } from "@/App/Tenants/Delete";
import { UpdateTenantBtn } from "@/App/Tenants/Update";

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import { CircleUserRound, MoreHorizontal, UsersRound } from "lucide-react";
import { SwitchActivateTenant } from "@/App/Tenants/ActivedOrDisabled";
import { LoadImage } from "../../../components/Loaders/LoadImage";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { TooltipComponent } from "@/components/ui/tooltip";

export const ComponentTable = ({ dataApi, updateFront, pageActions }) => {
  const navigate = useNavigate();

  return (
    <>
      <Table className="bg-zinc-50 rounded shadow dark:bg-[#2c2c2c]">
        <TableHeader>
          <TableRow>
            <TableHead>Foto</TableHead>
            <TableHead>Nome</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Telefone</TableHead>
            <TableHead className="text-center">Ativo</TableHead>
            <TableHead className="text-center">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {dataApi?.data?.map((tenant: TypeTenantsProps, index) => (
            <TableRow key={tenant?.id}>
              <TableCell>
                {tenant?.logo ? (
                  <LoadImage
                    src={tenant?.logo}
                    className="size-7 aspect-square object-cover rounded"
                  />
                ) : (
                  <CircleUserRound
                    strokeWidth={1.5}
                    className="text-slate-700 size-7 dark:text-[#F4F4F5]"
                  />
                )}
              </TableCell>
              <TableCell>{tenant?.name}</TableCell>
              <TableCell>{tenant?.email}</TableCell>
              <TableCell>{Mask.maskPhone(tenant?.phone)}</TableCell>
              <TableCell>
                <SwitchActivateTenant
                  defaultChecked={tenant?.is_active ? true : false}
                  tenantId={tenant?.uuid}
                  updateFront={updateFront}
                />
              </TableCell>
              <TableCell className="flex justify-center">
                <div className="flex gap-1 w-full justify-center">
                  <Button
                    variant="ghost"
                    size="icon"
                    className="mx-1 size-7 p-0 text-slate-900 hover:bg-stone-950/10 dark:text-[#F4F4F5]"
                    onClick={() => navigate(`/${tenant?.uuid}/usuarios`)}
                  >
                    <UsersRound className="size-5" />
                  </Button>
                  <TooltipComponent label="Editar">
                    <UpdateTenantBtn
                      setTenantsData={updateFront}
                      idTenant={tenant.uuid}
                      arrKey={index}
                    />
                  </TooltipComponent>
                  <TooltipComponent label="Excluir">
                    <DeleteTenantBtn
                      idTenant={tenant.uuid}
                      updateFront={updateFront}
                      nameTenant={tenant.name}
                    />
                  </TooltipComponent>
                  <TooltipComponent label="Visualizar">
                    <ShowTenantBtn uuidTenant={tenant.uuid} />
                  </TooltipComponent>
                </div>
              </TableCell>
            </TableRow>
          ))}
          {dataApi?.data?.length < 1 && (
            <TableRow>
              <TableCell colSpan={5}>Nada foi encontrado.</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <div className="flex justify-between mb-3">
        {dataApi?.data?.length > 0 ? (
          <span className="font-medium">
            Exibindo {dataApi?.current_page} de um total de {dataApi.last_page}
          </span>
        ) : (
          <span className="font-medium">Exibindo 0 de um total de 0</span>
        )}
        {dataApi?.last_page > 1 && (
          <Pagination className="">
            <PaginationContent>
              <PaginationItem>
                <PaginationPrevious
                  href="#"
                  className="bg-red-700 hover:bg-red-800 h-8"
                  onClick={pageActions.previous}
                />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink
                  href="#"
                  className="size-8 bg-transparent border-2 border-red-700 text-slate-900 font-bold cursor-auto hover:bg-transparent"
                >
                  <span className="pointer-events-none">
                    {dataApi.current_page}
                  </span>
                </PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink
                  href="#"
                  className="text-black h-8 hover:bg-stone-950/10"
                  onClick={pageActions.lastPage}
                >
                  <MoreHorizontal className="h-4 w-4" />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationNext
                  href="#"
                  className="bg-red-700 hover:bg-red-800 h-8"
                  onClick={pageActions.next}
                />
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        )}
      </div>
    </>
  );
};
